let navigator: ((path: string) => void) | null = null;

export const setNavigator = (navigateFn: (path: string) => void) => {
  navigator = navigateFn;
};

export const navigateTo = (path: string) => {
  if (navigator) {
    navigator(path);
  } else {
    console.warn("Navigator not initialized yet");
  }
};